import { httpCreate } from './http';

const http = httpCreate('/shop/api/product-statistics');

export const productStatistics = {
	// 商品访客排行榜
	getRankList() {
		return http.get('/rank-list');
	},
};
